import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "b-page-tie-panoramas",
  class: "b-page-tie-panoramas js-page-tie-panoramas page"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Шаг 2 / 3. Привязка панорам ")
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = {
  key: 0,
  class: "progress"
}
const _hoisted_7 = ["aria-valuenow"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panorama = _resolveComponent("Panorama")!
  const _component_ShootingPinPlan = _resolveComponent("ShootingPinPlan")!
  const _component_ShootingPinControls = _resolveComponent("ShootingPinControls")!
  const _component_ShootingPinTable = _resolveComponent("ShootingPinTable")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "dragContainer",
    class: "shooting-pin container",
    onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
    onDragenter: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
  }, [
    (_ctx.shooting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", null, " Съемка №" + _toDisplayString(_ctx.shooting.id) + ", проект «" + _toDisplayString(_ctx.project.title) + "», " + _toDisplayString(_ctx.shootingDate), 1),
          _createElementVNode("h2", null, [
            _hoisted_2,
            _createElementVNode("a", {
              href: `/admin/projects/${_ctx.project.id}`,
              class: "btn btn-link"
            }, " Вернуться к проекту ", 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                disabled: "",
                class: "btn btn-info",
                style: _normalizeStyle(!_ctx.progressBarState.show ? {'margin-bottom': '1rem'} : {}),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileUploader.click()))
              }, " Добавить панорамы ", 4),
              (_ctx.progressBarState.show)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "progress-bar",
                      role: "progressbar",
                      "aria-valuenow": _ctx.progressBarState.progress,
                      style: _normalizeStyle(_ctx.progressBarStyle),
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 12, _hoisted_7)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("input", {
                type: "file",
                accept: "image/jpeg,image/png",
                multiple: "",
                ref: "fileUploader",
                class: "d-none",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadPanoramas && _ctx.loadPanoramas(...args)))
              }, null, 544),
              (_ctx.activePanorama)
                ? (_openBlock(), _createBlock(_component_Panorama, {
                    key: 1,
                    "panorama-id": _ctx.activePanorama.id,
                    "panorama-filename": _ctx.activePanorama.filename,
                    class: "shooting-pin__panorama"
                  }, null, 8, ["panorama-id", "panorama-filename"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ShootingPinPlan, {
                plans: _ctx.plans,
                activePlanIndex: _ctx.activePlanIndex,
                mapPoints: _ctx.pointsForPlan,
                activePointId: _ctx.activePointId,
                onChangeActivePoint: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activePointId = $event)),
                onChangeActivePlanIndex: _ctx.setActivePlan,
                onPointMoved: _ctx.pointMovedHandler
              }, null, 8, ["plans", "activePlanIndex", "mapPoints", "activePointId", "onChangeActivePlanIndex", "onPointMoved"]),
              _createVNode(_component_ShootingPinControls, {
                activePointIsUnpinnable: _ctx.activePointIsUnpinnable,
                activePointIsPinnable: _ctx.activePointIsPinnable,
                hasPreviousPanorama: _ctx.hasPreviousPanorama,
                hasNextPanorama: _ctx.hasNextPanorama,
                onPinPanoramaToActivePoint: _ctx.pinPanoramaToActivePoint,
                onUnpinPanoramaFromActivePoint: _ctx.unpinPanoramaFromActivePoint,
                onSetPreviousPanoramaActive: _ctx.setPreviousPanoramaActive,
                onSetNextPanoramaActive: _ctx.setNextPanoramaActive,
                onCallCreatePoint: _ctx.createPoint
              }, null, 8, ["activePointIsUnpinnable", "activePointIsPinnable", "hasPreviousPanorama", "hasNextPanorama", "onPinPanoramaToActivePoint", "onUnpinPanoramaFromActivePoint", "onSetPreviousPanoramaActive", "onSetNextPanoramaActive", "onCallCreatePoint"])
            ]),
            _createVNode(_component_ShootingPinTable, {
              panoramas: _ctx.panoramas,
              activePanoramaIndex: _ctx.activePanoramaIndex,
              plans: _ctx.plans,
              points: _ctx.points,
              unpinButtonIsEnabled: _ctx.unpinFromActivePanoramaButtonIsEnabled,
              onUnpinPointFromActivePanorama: _ctx.unpinPointFromActivePanorama,
              onLineClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setActivePanorama($event))),
              onSubmit: _ctx.submit
            }, null, 8, ["panoramas", "activePanoramaIndex", "plans", "points", "unpinButtonIsEnabled", "onUnpinPointFromActivePanorama", "onSubmit"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 544))
}